import axios from 'axios';
import { useState } from 'react';

import { IconButton, Tooltip, CircularProgress } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';

import { backendHOST } from '../../../client-config/client-config.js';

export function TaskCloseButton({ taskId, user, onClosed }) {
  const [loading, setLoading] = useState(false);

  async function markAsReady() {
    const taskToClose = {
      id_task: taskId,
      id_user: user.ext_id_user,
    };

    try {
      setLoading(true);

      await axios.post(
        `${backendHOST}/api/taskManager/closeTask`,
        taskToClose,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (onClosed) {
        await onClosed();
      }
    } catch (err) {
      console.error('Task lezárási hiba:', err);
      alert('Hiba a feladat lezárása során.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Tooltip title='Feladat elvégezve'>
      <span>
        <IconButton color='success' onClick={markAsReady} disabled={loading}>
          {loading ? <CircularProgress size={22} /> : <CheckIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
